export default __webpack_public_path__ + "static/media/band3.379145e2.jfif";